"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var constants_exports = {};
__export(constants_exports, {
  ACCURATE_EN_FOUR_DIGIT_ISO: () => ACCURATE_EN_FOUR_DIGIT_ISO,
  ASBIS_UI_THEME_PREFIX: () => ASBIS_UI_THEME_PREFIX,
  ISO_MAP: () => ISO_MAP
});
module.exports = __toCommonJS(constants_exports);
const ASBIS_UI_THEME_PREFIX = "theme";
const ISO_MAP = {
  bg: "bg-bg",
  zh: "zh-cn",
  cs: "cs-cz",
  da: "da-dk",
  nl: "nl-nl",
  en: "en-us",
  et: "et-ee",
  fi: "fi-fi",
  fr: "fr-fr",
  de: "de-de",
  hu: "hu-hu",
  is: "is-is",
  it: "it-it",
  ja: "ja-jp",
  ko: "ko-kr",
  no: "no-no",
  pl: "pl-pl",
  pt: "pt-br",
  ro: "ro-ro",
  ru: "ru-ru",
  sr: "sr-rs",
  sk: "sk-sk",
  es: "es-es",
  sv: "sv-se",
  uk: "uk-ua",
  ua: "uk-ua",
  hr: "hr-hr",
  ar: "ar-ar",
  cz: "cs-cz",
  lt: "lt-lt",
  hy: "hy-am",
  ka: "ka-ge",
  kk: "kk-kz",
  lv: "lv-lv",
  uz: "uz-uz",
  el: "el-gr",
  bs: "bs-ba",
  af: "en-za"
};
const ACCURATE_EN_FOUR_DIGIT_ISO = "en-en";
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  ACCURATE_EN_FOUR_DIGIT_ISO,
  ASBIS_UI_THEME_PREFIX,
  ISO_MAP
});
